<template>
  <div class="hp-image-upload">
    <label v-if="label" class="d-block mb-1">{{ label }}</label>
    <div class="d-flex align-items-center">
      <div class="hp-thumb mr-0 ml-2" :class="{ empty: !value }">
        <img v-if="value" :src="value" :alt="label || 'preview'">
        <span v-else class="text-muted small">بدون تصویر</span>
      </div>
      <div class="flex-grow-1">
        <CInput :value="value" placeholder="آدرس تصویر یا آپلود کنید" size="sm" class="mb-1" @input="$emit('input', $event)" />
        <input ref="file" type="file" accept="image/*" class="d-none" @change="onFile">
        <CButton color="info" size="sm" variant="outline" :disabled="busy" @click="$refs.file.click()">
          {{ busy ? 'در حال آپلود...' : 'آپلود تصویر' }}
        </CButton>
        <CButton v-if="value" color="danger" size="sm" variant="ghost" class="mr-1" @click="$emit('input', '')">حذف</CButton>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadHomepageImage } from './hpApi'

export default {
  name: 'HpImageUpload',
  props: { value: { type: String, default: '' }, label: { type: String, default: '' } },
  data() {
    return { busy: false }
  },
  methods: {
    notify(msg) {
      if (this.$toast) this.$toast.open({ message: msg, type: 'error' })
      else alert(msg)
    },
    onFile(e) {
      const f = e.target.files && e.target.files[0]
      if (!f) return
      this.busy = true
      uploadHomepageImage(f).then((res) => {
        if (res.data && res.data.url) this.$emit('input', res.data.url)
        else this.notify((res.data && res.data.msg) || 'خطا در آپلود')
      }).catch((err) => {
        const msg = (err.response && err.response.data && err.response.data.msg) || 'خطا در آپلود'
        this.notify(msg)
      }).finally(() => {
        this.busy = false
        e.target.value = ''
      })
    }
  }
}
</script>

<style scoped>
.hp-thumb { width: 96px; height: 64px; border: 1px solid #d8dbe0; border-radius: 6px; overflow: hidden; display: flex; align-items: center; justify-content: center; background: #f7f7f9; flex-shrink: 0; }
.hp-thumb img { width: 100%; height: 100%; object-fit: cover; }
</style>
